<div class="brand">
  @if (logoSrc()) {
    <img class="brand-logo" [src]="logoSrc()" [alt]="label() || 'logo'" />
  }
  @if (label()) {
    <span class="brand-label">{{ label() }}</span>
  }
</div>
